var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { isValid, parse } from 'date-fns';
import styled from 'styled-components';
import { ENTER_KEY, ESCAPE_KEY } from '../../../../const/keyNames';
import { formatDate } from '../../../../helpers/dateValidation';
import Textfield from '../../../atoms/Textfield';
import { ErrorIcon } from '../subcomponents';
import { validateDateInput } from './helpers';
const StyledDatePickerTextfield = styled(Textfield) `
  text-align: left;
  width: 100%;
`;
export const dateFormat = 'MM/dd/yyyy';
const DatePickerTextfield = (_a) => {
    var { idTextField = 'datePicker-input', onBlurHandler = () => { }, placeholderLabel, helpText, inputDate, minDate, maxDate, excludeDates, startDateErrorMessage, endDateErrorMessage, excludeDatesErrorMessage, error, required, rightIcon, handleDateTextFieldChange, handleDateTextFieldKeyDown, isReadOnly, dataObject, dataReason, dataType, dataAnalytics } = _a, props = __rest(_a, ["idTextField", "onBlurHandler", "placeholderLabel", "helpText", "inputDate", "minDate", "maxDate", "excludeDates", "startDateErrorMessage", "endDateErrorMessage", "excludeDatesErrorMessage", "error", "required", "rightIcon", "handleDateTextFieldChange", "handleDateTextFieldKeyDown", "isReadOnly", "dataObject", "dataReason", "dataType", "dataAnalytics"]);
    const [formattedDate, setFormattedDate] = useState(inputDate);
    const [invalidDate, setInvalidDate] = useState('');
    useEffect(() => {
        const parsedInputDate = parse(inputDate, dateFormat, new Date());
        const isDateValid = isValid(parsedInputDate);
        if (isDateValid && formattedDate !== inputDate) {
            setFormattedDate(formatDate(inputDate));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputDate]);
    useEffect(() => {
        const checkedDateMessage = validateDateInput({
            minDate,
            maxDate,
            excludeDates,
            formattedDate,
            startDateErrorMessage,
            endDateErrorMessage,
            excludeDatesErrorMessage
        });
        setInvalidDate(checkedDateMessage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formattedDate]);
    return (_jsx(StyledDatePickerTextfield, Object.assign({ id: idTextField, placeholder: placeholderLabel, type: "text", maxLength: 10, isDisabled: isReadOnly, error: error || invalidDate, value: formattedDate, rightIcon: !isReadOnly && rightIcon, helpText: helpText, width: "100%", errorIcon: _jsx(ErrorIcon, {}), required: required, onKeyDown: (event) => {
            const blurOutInputField = () => {
                const inputField = event.target;
                inputField.blur();
            };
            if (event.key === ENTER_KEY) {
                // value entered , handle submit at parent
                handleDateTextFieldKeyDown(formattedDate);
                blurOutInputField();
            }
            if (event.key === ESCAPE_KEY) {
                blurOutInputField();
            }
        }, onChange: (e) => {
            const { target: { value: updatedValue } } = e;
            const updatedFormattedDate = formattedDate.length > updatedValue.length
                ? updatedValue
                : formatDate(e.target.value);
            const updatedDateErrorMessage = validateDateInput({
                minDate,
                maxDate,
                excludeDates,
                formattedDate: updatedFormattedDate,
                startDateErrorMessage,
                endDateErrorMessage,
                excludeDatesErrorMessage
            });
            setFormattedDate(updatedFormattedDate);
            handleDateTextFieldChange === null || handleDateTextFieldChange === void 0 ? void 0 : handleDateTextFieldChange({
                date: updatedFormattedDate,
                errorMessage: updatedDateErrorMessage,
                value: updatedValue
            });
        }, onBlur: () => {
            const calendarElement = document.querySelector('.react-datepicker-popper.calendar');
            /*
             * React 17 will trigger this on selection of the date picker (known bug).
             * This code is to try to check if the date picker was used or not and conditionally
             * invoke the callback
             */
            if (!calendarElement) {
                onBlurHandler(formattedDate);
            }
        }, "data-object": dataObject, "data-reason": dataReason, "data-type": dataType, "data-analytics": dataAnalytics }, props)));
};
export default DatePickerTextfield;
//# sourceMappingURL=index.js.map